import { AppContext } from "App";

import { IMenuClient } from "@multiweb/clients/menu";
import { IconCode, IMenuData, IMenuItemData, MenuItemType } from "@multiweb/types/contracts";
import { Mutable } from "Global/Base/types";
import { EnumUtils } from "Global/Base/Utils/EnumUtils";
import { ASServices } from "OW.Remoting/Basic/ServiceEndpoints";
import { RequestContextWithoutTransactionContextId } from "../../../RequestContextWithoutTransactionContextId";
import { BaseClient } from "../BaseClient";

/**
 * @internal
 */
export class MenuClient extends BaseClient implements IMenuClient {
    public async getMenuItems(requestContext?: RequestContextWithoutTransactionContextId): Promise<IMenuData> {
        const { items, profiles, rootItems } = await this._communicationManager
            .callGETRequest("", ASServices.menu, { profile: "FormProfileMW" }, undefined, requestContext);

        for (const key in items) {
            const menuItem = items[key] as Mutable<IMenuItemData>;
            if (!menuItem.icon && menuItem.type !== MenuItemType.folder) {
                menuItem.icon = EnumUtils.getEnumValueFromValue(IconCode, AppContext.instance.configuration.defaultMenuItemsIcon);
            }
        }

        return {
            items,
            profiles,
            rootFormItemIds: rootItems, // Jedná se o pole identifikátorů, je vhodné přejmenování
        };
    }
}
